/**
 * Obsługa głosowania przez weryfikację e-mail
 */

(function($) {
    'use strict';

    function handleEmailVoteVerification() {
        var urlParams = new URLSearchParams(window.location.search);
        var verifyVote = urlParams.get('verify_vote');
        var token = urlParams.get('token');
        var project = urlParams.get('project_id');

        if (verifyVote === '1' && token && project) {
            var verificationStatus = $('#verification-status');
            if (verificationStatus.length === 0) {
                $('.online-vote-response').prepend('<div id="verification-status" style="text-align: center;color: #fff; margin: 10px 0px;background-color:#0171BA;border-radius:5px"><p>Trwa weryfikacja głosu...</p></div>');
                verificationStatus = $('#verification-status');
            }

            $.get(ajax.url, {
                action: 'kolo_email_vote_confirm',
                token: token,
                project: project
            })
            .done(function(data) {
                setTimeout(function() {
                    verificationStatus.html('<div style="color: #ffffff;background: #003061;border: 1px solid #003061;padding: 15px;border-radius: 4px;"><p><strong>✓ Głos został pomyślnie oddany!</strong></p><p>Dziękujemy za udział w głosowaniu.</p></div>');
                }, 1000);
            })
            .fail(function() {
                verificationStatus.html('<div style="color: #dc3545; background: #f8d7da; border: 1px solid #f5c6cb; padding: 15px; border-radius: 4px;"><p><strong>Błąd weryfikacji</strong></p><p>Nie udało się potwierdzić głosu. Link może być nieprawidłowy lub wygasły.</p><a href="' + window.location.origin + '" class="button" style="margin-top: 10px;">Powrót do strony głównej</a></div>');
            });
        }
    }

    function trackEmailVoteEvent(eventName, projectId) {
        if (typeof window.dataLayer !== 'undefined') {
            window.dataLayer.push({
                'event': eventName,
                'vote_type': 'email',
                'project_id': projectId
            });
        }
    }

    function handleEmailVoteForm() {
        $(document).on('submit', 'form[id*="emailvote"]', function(e) {
            var form = $(this);
            var projectId = form.find('input[name="project_id"]').val();
            
            trackEmailVoteEvent('email_vote_started', projectId);
        });

        $(document).on('ajax:success', 'form[id*="emailvote"]', function(e, data) {
            if (data && data.success) {
                var projectId = $(this).find('input[name="project_id"]').val();
                trackEmailVoteEvent('email_vote_link_sent', projectId);
            }
        });
    }

    function setupPrivacyToggle() {
        $(document).on('click', '[data-toggle="privacy-info"]', function(e) {
            e.preventDefault();
            e.stopPropagation();
            var targetId = $(this).attr('href') || $(this).data('target');
            $(targetId).slideToggle();
        });
    }

    function setupEmailValidation() {
        $(document).on('input', 'input[name="voter_email"]', function() {
            var email = $(this).val();
            var isValid = /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);
            
            $(this).siblings('.email-validation-message').remove();
            
            if (email.length > 0 && !isValid) {
                $(this).after('<small class="email-validation-message" style="color: #dc3545;">Podaj prawidłowy adres e-mail</small>');
            }
        });
    }

    $(document).ready(function() {
        handleEmailVoteVerification();
        handleEmailVoteForm();
        setupPrivacyToggle();
        setupEmailValidation();
    });

})(jQuery);